import React from 'react'

function ModalForm({ isOpen, onClose, children }) {
    if (!isOpen) return null;

    return (
        <div className="z-50 fixed inset-0 flex justify-center items-center bg-gray-600 bg-opacity-50">
            <div className="bg-white shadow-lg p-6 rounded-lg w-1/2">
                <button
                    className="top-2 right-2 absolute text-gray-700"
                    onClick={onClose}
                >
                    &times;
                </button>
                {children}
            </div>
        </div>
    );
}

export default ModalForm